import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useSelector } from "react-redux";
// import component
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";

// import components
import RegisterForm from '../components/RegisterForm';


function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}
const dashboardRoutes = [];

const RegisterPage = (props) => {
  const { t, i18n } = useTranslation();

  const { ...rest } = props;
// redux
const theme = useSelector(state => state.theme)
  return (
    <div className="page_wrap">
      <ScrollToTopOnMount />
      <Header className="header"
        color="transparent"
        routes={dashboardRoutes}
        brand={
          theme == 'dark' ? <img src={require("../assets/images/logo_white.svg")} alt="logo" className="img-fluid" /> : <img src={require("../assets/images/logo.svg")} alt="logo" className="img-fluid" />
        }
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 20,
          color: "dark",
        }}
        {...rest} />
      <div className="login_container">    
        <div className="container">
          <div className="row align-items-center">
            {/* <div className="col-sm-12 col-md-6">
              <div className="logo_bg_shadow" data-aos="fade-up">
                <img src={require("../assets/images/logo_bg.svg")} alt="logo" className="img-fluid" />
              </div>
            </div> */}
            <div className="col-sm-12 col-md-6 mx-auto">
              <RegisterForm />            
            </div>
          </div>
          <p className="text-center"><Link to="/privacy-policy">Privacy Policy</Link></p>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;